import {GeneratedType} from "@shareledgerjs/signing";
import Long from "long";

import {BaseClient} from "../../baseclient";
import {MsgExecuteContractEncodeObject, MsgInstantiateContractEncodeObject, WasmTxExtension} from "../wasm";
import {ExecuteMsg, InstantiateMsg} from "./types/CwSoulbound.types";

export function createSbtTypes(): ReadonlyArray<[string, GeneratedType]> {
  return [];
}

export interface SbtTxExtensionMethods {
  instantiate(owner: string, codeId: Long, label: string, msg: InstantiateMsg): MsgInstantiateContractEncodeObject;
  mint(contract: string, owner: string, recipient: string): MsgExecuteContractEncodeObject;
  setMinter(contract: string, owner: string, recipient: string): MsgExecuteContractEncodeObject;
}

export interface SbtTxExtension {
  readonly sbt: SbtTxExtensionMethods;
}

export function SbtTxExtension<T extends {new (...args: any[]): BaseClient & SbtTxExtension & WasmTxExtension}>(constructor: T): T {
  return class extends constructor {
    override get sbt() {
      return {
        ...super["sbt"],
        instantiate: (owner: string, codeId: Long, label: string, msg: InstantiateMsg) => {
          return this.wasm.instantiateContract(owner, owner, codeId, label, msg, []);
        },
        mint: (contract: string, owner: string, recipient: string) => {
          return this.wasm.executeContract<ExecuteMsg>(
            owner,
            contract,
            {
              mint: {
                to: recipient
              }
            },
            []
          );
        },
        setMinter: (contract: string, owner: string, recipient: string) => {
          return this.wasm.executeContract<ExecuteMsg>(
            owner,
            contract,
            {
              set_minter: {
                minter: recipient
              }
            },
            []
          );
        }
      };
    }
  };
}
